import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup } from "../../store/popupSlice";

export default function PharmacyOrder() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="pharmacy-order-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="heading center-heading"><span className="gradiant-color">Optimal Online Ordering  </span> For<br /> Diverse Pharmacies.</h2>
            </div>

            <div className="col-lg-4 col-md-6">
              <Link onClick={() => dispatch(openPopup())} to={""}>
                <div className="pharmacy-order-box">
                  <div className="pharm-image">
                    <img src="./assets/home/pharmacy-order-1.webp" alt="pharmacy" className="img-responsive" />
                  </div>
                  <div className="pharm-details">
                    <h3>Standalone Pharmacy</h3>
                    <p>Streamline operations with online solutions designed for independent pharmacies to enhance customer convenience.</p>
                    <span>try demo <FontAwesomeIcon icon={faArrowRight}/> </span>
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="col-lg-4 col-md-6">
              <Link onClick={() => dispatch(openPopup())} to={""}>
                <div className="pharmacy-order-box">
                  <div className="pharm-image">
                    <img src="./assets/home/pharmacy-order-2.webp" alt="pharmacy" className="img-responsive" />
                  </div>
                  <div className="pharm-details">
                    <h3>Pharmacy Marketplace</h3>
                    <p>Empower pharmacies with a unified platform connecting customers to multiple stores, ensuring seamless purchasing.</p>
                    <span>try demo <FontAwesomeIcon icon={faArrowRight}/> </span>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-lg-4 col-md-6">
              <Link onClick={() => dispatch(openPopup())} to={""}>
                <div className="pharmacy-order-box">
                  <div className="pharm-image">
                    <img src="./assets/home/pharmacy-order-3.webp" alt="pharmacy" className="img-responsive" />
                  </div>
                  <div className="pharm-details">
                    <h3>Pharmacy Chains</h3>
                    <p>Optimize operations by centralizing management for multiple outlets, enhancing efficiency and customer reach.</p>
                    <span>try demo <FontAwesomeIcon icon={faArrowRight}/> </span>
                  </div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <img loading='lazy' src="./assets/home/pharmacy-order-vec.webp" alt="vector" className="img-responsive pharm-order-vec" />
      </section>
    </>
  )
}
